import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ORDER_STATUS_ORDERED,
  ORDER_STATUS_DEALER_PROCESSING,
  ORDER_STATUS_DEALER_ACCEPTED,
  ORDER_STATUS_DEALER_CANCELLED,
  ORDER_STATUS_DEALER_DECLINED,
  ORDER_STATUS_DEALER_DELIVERED,
  ORDER_STATUS_CONSUMER_CANCELLED,
} from '@chama/utils/constants/status';

const statusMap = {
  [ORDER_STATUS_ORDERED]: 'Ordered',
  [ORDER_STATUS_DEALER_PROCESSING]: 'Dealer processing',
  [ORDER_STATUS_DEALER_ACCEPTED]: 'Dealer accepted',
  [ORDER_STATUS_DEALER_CANCELLED]: 'Dealer cancelled',
  [ORDER_STATUS_DEALER_DECLINED]: 'Dealer declined',
  [ORDER_STATUS_DEALER_DELIVERED]: 'Dealer delivered',
  [ORDER_STATUS_CONSUMER_CANCELLED]: 'Consumer Cancelled',
};

const getOrderStatusLabel = (orderStatus, isCSUser) => {
  const getFormattedMessageId = () => {
    const base = 'order_event_history';

    if (isCSUser) {
      return `${base}.${orderStatus}.cs`;
    }

    return `${base}.${orderStatus}`;
  };

  return (
    <FormattedMessage
      id={getFormattedMessageId()}
      defaultMessage={statusMap[orderStatus] || orderStatus}
    />
  );
};

export default getOrderStatusLabel;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/EventHistory/get-order-status-label.jsx